import { useMutation, useQuery } from 'react-query'

import { QueryKey } from '../../../common/api'
import { queryClient } from '../../../common/providers/query'
import { userApi } from '../api/user.api'
import { InviteUserDto } from '../types/user.types'

export const useGetUserInvitation = (token?: string) => {
  return useQuery(
    [QueryKey.Invitation, token],
    async () => {
      if (!token) {
        return null
      }

      const response = await userApi.getUserInvitation(token)

      return response.data
    },
    {
      enabled: !!token,
      retry: 1,
    },
  )
}

export const useGetInvitedUsers = () => {
  return useQuery([QueryKey.InvitedUsers], async () => {
    const response = await userApi.getInvitedUsers()

    return response.data
  })
}

export const useInviteUser = () => {
  return useMutation(
    async (user: InviteUserDto) => {
      const response = await userApi.inviteUser(user)

      return response.data
    },
    {
      onSuccess: async () => {
        return Promise.all([
          queryClient.invalidateQueries(QueryKey.InvitedUsers),
          queryClient.invalidateQueries(QueryKey.Invitation),
          queryClient.invalidateQueries(QueryKey.Users),
        ])
      },
    },
  )
}

export const useGetUsers = (withInvitedUsers = false) => {
  return useQuery(
    [QueryKey.Users, withInvitedUsers],
    async () => {
      const response = await userApi.getUsers(withInvitedUsers)

      return response.data
    },
    { retry: 1 },
  )
}

export const useSubmitQuiz = () => {
  return useMutation(async () => {
    const response = await userApi.submitQuiz()

    return response.data
  })
}
